var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9996 100C22.4297 100 0 77.5703 0 49.9996C0 22.4297 22.4297 0 49.9996 0C77.5695 0 99.9992 22.4297 99.9992 49.9996C99.9992 77.5703 77.5695 100 49.9996 100ZM49.9996 4.93141C25.1494 4.93141 4.93141 25.1494 4.93141 49.9996C4.93141 74.8506 25.1494 95.0686 49.9996 95.0686C74.8498 95.0686 95.0678 74.8506 95.0678 49.9996C95.0678 25.1494 74.8506 4.93141 49.9996 4.93141Z",
    fill: "#923F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8015 80.0835H59.8701C59.8701 75.4463 55.3685 71.6746 49.8363 71.6746C44.3041 71.6746 39.8025 75.4471 39.8025 80.0835H34.8711C34.8711 72.7274 41.5844 66.7432 49.8363 66.7432C58.0882 66.7432 64.8015 72.7266 64.8015 80.0835Z",
    fill: "#923F3F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 56.1716,
    x2: 28.1716,
    y2: 45,
    stroke: "#923F3F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 56.1716,
    x2: 28.1716,
    y2: 45,
    stroke: "#923F3F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 17.799,
    y2: -2,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 28 59)",
    stroke: "#923F3F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 17.799,
    y2: -2,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 28 59)",
    stroke: "#923F3F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 56.1716,
    x2: 83.1716,
    y2: 45,
    stroke: "#923F3F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: 56.1716,
    x2: 83.1716,
    y2: 45,
    stroke: "#923F3F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 17.799,
    y2: -2,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 83 59)",
    stroke: "#923F3F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 17.799,
    y2: -2,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 83 59)",
    stroke: "#923F3F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.ebdd2f6b0782c27f669ad17a76209fb6.svg";
export { ForwardRef as ReactComponent };